import React from 'react';
import PropTypes from 'prop-types';
import { Table, Tab } from 'semantic-ui-react';
import './styles/TaskListPrint.scss';

export default class TaskListPrint extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <>
        <Table>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell colSpan={4}>
                {this.props.taskList &&
                  this.props.taskList.name &&
                  this.props.taskList.name}
              </Table.HeaderCell>
            </Table.Row>
            <Table.Row>
              <Table.HeaderCell>Task</Table.HeaderCell>
              <Table.HeaderCell>Assigned To</Table.HeaderCell>
              <Table.HeaderCell>Completed By</Table.HeaderCell>
              <Table.HeaderCell>Approved By</Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {this.props.taskList &&
              this.props.taskList.tasks &&
              this.props.taskList.tasks.map((t, tIndex) => {
                return (
                  <React.Fragment key={tIndex}>
                    {t.type === 'section' ? (
                      <Table.Row className="task-section">
                        <Table.Cell colSpan={4}>{t.name}</Table.Cell>
                      </Table.Row>
                    ) : (
                      <>
                        <Table.Row>
                          <Table.Cell>{t.name}</Table.Cell>
                          <Table.Cell>
                            {t.assignedTo && (
                              <>
                                {t.assignedTo.firstName} {t.assignedTo.lastName}
                              </>
                            )}
                          </Table.Cell>
                          <Table.Cell>
                            {t.completedBy && (
                              <>
                                {t.completedBy.firstName}{' '}
                                {t.completedBy.lastName}
                              </>
                            )}
                          </Table.Cell>
                          <Table.Cell>
                            {t.approvedBy && (
                              <>
                                {t.approvedBy.firstName} {t.approvedBy.lastName}
                              </>
                            )}
                          </Table.Cell>
                        </Table.Row>
                        {t.additionalFields &&
                          t.additionalFields.map((af, afIndex) => {
                            return (
                              <Table.Row key={afIndex}>
                                <Table.Cell>
                                  &nbsp;&nbsp;• <em>{af.name}</em>{' '}
                                  {af.description && `(${af.description})`}
                                </Table.Cell>
                                <Table.Cell colSpan={3}></Table.Cell>
                              </Table.Row>
                            );
                          })}
                      </>
                    )}
                  </React.Fragment>
                );
              })}
          </Table.Body>
        </Table>
      </>
    );
  }
}

TaskListPrint.propTypes = {
  taskList: PropTypes.object,
};
